export default "__VITE_ASSET__$T7Lx22F__"